// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("StorePromo", {
  id: __t.u64(),
  name: __t.string(),
  discountPercent: __t.u32(),
  appliesTo: __t.string(),
  startsAt: __t.u64(),
  endsAt: __t.u64(),
  isActive: __t.bool(),
  createdAt: __t.u64(),
});


